/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { NextResponse, type NextRequest } from "next/server";

import { getBestLocaleFromRequest } from "./locale";

/** Preserve Editor's news feed languages after locale and case redirects. */
export function processEditorNewsLocale(
	request: NextRequest,
	locales: string[],
	defaultLocale: string,
	newsLocales: string[],
	unsupportedLocaleMapping?: Record<string, string>,
): NextResponse | void {
	const { pathname } = request.nextUrl;
	if (pathname !== "/news" && !pathname.startsWith("/news/")) return;

	const locale = getBestLocaleFromRequest(request, locales, defaultLocale, unsupportedLocaleMapping);
	const newsLocale = locale === "es-MX" ? "es-ES" : newsLocales.includes(locale) ? locale : "en-US";
	if (newsLocale === locale) return;

	const destination = request.nextUrl.clone();
	// Keep even the default explicit, or an unsupported cookie would redirect again.
	destination.searchParams.set("lang", newsLocale);
	return NextResponse.redirect(destination, { headers: { Vary: "Accept-Language, Cookie" } });
}
